export const locales = {
  english: "en",
  french: "fr",
  arabic: "ar",
};
